import { ArrowUpRight } from 'lucide-react'
import { CADABLE_URL, disabledButton, secondaryButton } from './ui'

/** Entry to CADable. Until VITE_CADABLE_URL is set, it is a disabled placeholder of the same size. */
export default function CadableButton({ className = '' }: { className?: string }) {
  if (!CADABLE_URL) {
    return <button type="button" disabled className={`${disabledButton} ${className}`}>CADable · Coming soon</button>
  }
  return (
    <a href={CADABLE_URL} target="_blank" rel="noopener noreferrer" className={`${secondaryButton} ${className}`}>
      Open CADable <ArrowUpRight className="h-4 w-4" />
    </a>
  )
}
